function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.1 12.3c.9-1.3 1.5-2.9 1.5-4.7 0-4.1-3-7.4-6.6-7.4S5.4 3.5 5.4 7.6c0 1.8.6 3.4 1.5 4.7-1.7.6-3 2.2-3 4.2v2.9c0 2.4 2 4.4 4.4 4.4h7.4c2.4 0 4.4-2 4.4-4.4v-2.9c0-2-1.3-3.6-3-4.2zM6.8 7.6c0-3.3 2.3-5.9 5.2-5.9s5.2 2.6 5.2 5.9-2.3 5.9-5.2 5.9-5.2-2.7-5.2-5.9zM18.6 19c0 1.8-1.6 3.3-3.6 3.3H9c-2 0-3.6-1.5-3.6-3.3v-2.2c0-1.6 1.2-2.9 2.8-3.2 1.1.9 2.4 1.4 3.8 1.4s2.8-.5 3.8-1.4c1.6.3 2.8 1.6 2.8 3.2V19z"
});

function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgUserIcon;